export const port = 9999;
export const host = "localhost"; //"192.168.4.1";
export const uri = `http://${host}:${port}/ws`;
